import {
  AdvancedMarker,
  InfoWindow,
  useAdvancedMarkerRef,
} from '@vis.gl/react-google-maps'
import { LabLocation } from 'hooks/useLabScheduling/useLabscheduling'
import { useCallback, useEffect, useState } from 'react'

interface GoogleMarkerWithWindowProps {
  location: LabLocation
  position: { lat: number; lng: number }
  setFocus: () => void
  isFocused: boolean
}

const GoogleMarkerWithWindow = ({
  location,
  position,
  setFocus,
  isFocused,
}: GoogleMarkerWithWindowProps) => {
  const [markerRef, marker] = useAdvancedMarkerRef()

  const [infoWindowShown, setInfoWindowShown] = useState(false)

  // Open + Close window
  // If opening window, also set focus
  const handleMarkerClick = useCallback(() => {
    if (!infoWindowShown) {
      setFocus()
    }

    setInfoWindowShown((isShown) => !isShown)
  }, [])

  const handleClose = useCallback(() => setInfoWindowShown(false), [])

  useEffect(() => {
    if (isFocused) {
      setInfoWindowShown(true)
    }

    if (!isFocused) {
      handleClose()
    }
  }, [isFocused])

  const {
    address: { address1, address2, city, state, zipcode },
  } = location
  const formattedAddress = `${address1} ${address2}, ${city}, ${state}, ${zipcode}`

  return (
    <>
      <AdvancedMarker
        ref={markerRef}
        position={position}
        onClick={handleMarkerClick}
      />

      {infoWindowShown && (
        <InfoWindow anchor={marker} onClose={handleClose}>
          <p>{formattedAddress}</p>
        </InfoWindow>
      )}
    </>
  )
}

export default GoogleMarkerWithWindow
